import { render, staticRenderFns } from "./SubscriptionPackageForm.vue?vue&type=template&id=88ec2d50"
import script from "./SubscriptionPackageForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionPackageForm.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPackageForm.vue?vue&type=style&index=0&id=88ec2d50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports